import { MessagingTokenPlatform } from '@backend/domain'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsEmail, IsEnum, IsNotEmpty, IsOptional, IsString, IsUUID, Length, MinLength } from 'class-validator'

export class UserResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	firstName: string

	@ApiProperty({ type: String })
	lastName: string

	@ApiProperty({ type: String })
	fullName: string

	@ApiProperty({ type: String, format: 'email' })
	email: string

	@ApiProperty({ type: Boolean })
	emailVerified: boolean

	@ApiProperty({ type: String })
	preferedLanguage?: string

	@ApiProperty({ type: Date })
	createdAt: Date
}

export class CreateUserRequest {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	firstName: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	lastName: string

	@ApiProperty({ type: String, format: 'email' })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	email: string
}

export class CreateUserWithPasswordRequest extends CreateUserRequest {
	@ApiProperty({ type: String, format: 'password', minLength: 8 })
	@IsNotEmpty()
	@IsString()
	@MinLength(8)
	password: string
}

export class UpdateUserRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	id: string

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	@IsString()
	@Length(2, 60)
	firstName?: string

	@ApiPropertyOptional({ type: String, minLength: 2, maxLength: 60 })
	@IsOptional()
	@IsString()
	@Length(2, 60)
	lastName?: string

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	@IsString()
	preferedLanguage?: string
}

export class UpdateMessagingTokenRequest {
	@ApiProperty({ enum: MessagingTokenPlatform })
	@IsNotEmpty()
	@IsEnum(MessagingTokenPlatform)
	platform: MessagingTokenPlatform

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	token: string
}
